import { render, staticRenderFns } from "./BallotProgress.vue?vue&type=template&id=2445497c&"
import script from "./BallotProgress.vue?vue&type=script&lang=js&"
export * from "./BallotProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports